import { fetchAPI } from "../../../../../config/axios";
import {
  PembobotanAction,
  PembobotanActionType,
  PembobotanDataModel,
} from "./types";

export const Pembobotan: PembobotanDataModel = {
  main: {
    data: [],
    total: 0,
  },
};

export const PembobotanReducer = (
  state: PembobotanDataModel = Pembobotan,
  action: PembobotanAction
): PembobotanDataModel => {
  switch (action.type) {
    case PembobotanActionType.GetPembobotan:
      return { ...state, main: action.data };
    default:
      return state;
  }
};

export const PembobotanCommand = {
  GetPembobotan: (params: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().get(
          "/tj-parameter-penilaian/kriteria-penilaians",
          { params }
        );
        dispatch({
          type: PembobotanActionType.GetPembobotan,
          data: {
            data: response.data.data.data,
            total: response.data.data.total,
          },
        });
      } catch (error) {
        throw error;
      }
    };
  },
  CreatePembobotan: (body: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().post(
          "/tj-parameter-penilaian/kriteria-penilaian",
          body
        );
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
  UpdatePembobotan: (body: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().patch(
          "/tj-parameter-penilaian/kriteria-penilaian",
          body
        );
        return response;
      } catch (error) {
        throw error;
      }
    };
  }
};
